import axios from 'axios'
import includes from 'lodash/includes'
import { CREATE_TOKEN, UPDATE_VIEW } from './types'
import { endpoints } from '../config/endpoints'
import { view_types } from '../config/viewTypes'
import trackingEvents from '../services/trackingEvents'
import getGAClientId from '../services/getGAClientId'
import { deleteCookie } from 'services/cookies'

const allowed_statuses = [200, 201]

export const createToken = (email, document_file_name, document_url, subscription_identifier) => dispatch => {
  return axios.post(endpoints.users_url, {
    email,
    document_file_name,
    document_url,
    subscription_identifier,
    current_url: window.location.href || null,
    client_id: getGAClientId()
  })
}

export const updateStore = (response, subscription_identifier) => dispatch => {
  handleTrackingEvents(response, subscription_identifier)
  updateCurrentStore(
    dispatch,
    response.data.token,
    viewState(response.data.doi)
  )
}

export const updateToken = () => dispatch => {
  axios.post(endpoints.users_url)
    .then(function (response) {
      if (includes(allowed_statuses, response.status)) {
        updateCurrentStore(
          dispatch,
          response.data.token,
          viewState(response.data.doi)
        )
      }

      if (response.status === 204) {
        deleteCookie('ftipstate')
        updateCurrentStore(
          dispatch,
          null,
          view_types.new
        )
      }

    })
    .catch(function (error) {
      console.log(error);
    });
}

export const removeToken = () => dispatch => {
  deleteCookie('ftipstate')
  updateCurrentStore(
    dispatch,
    null,
    view_types.new
  )
}

function updateCurrentStore(dispatch, token, view) {
  dispatch({ type: CREATE_TOKEN, token })
  dispatch({ type: UPDATE_VIEW, view })
}

function viewState(state) {
  return state ? view_types.doi : view_types.soi
}

function handleTrackingEvents(response, subscription_identifier) {
  if (response.status === 201) {
    trackingEvents().success(response.data.token, subscription_identifier)
  } else {
    if (response.data.doi) {
      trackingEvents().confirmed()
    } else {
      trackingEvents().unconfirmed()
    }
  }
}
